<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>


export default {
  data() {
    return {};
  },
  components: {},
  created() {

  },
};
</script>

<style lang="less">

#app {
  height: 100%;
  min-height: 620px;
  display: flex;
}
.settlement {
  min-width: 220px;
  max-width: 220px;
  flex: 2;
}
.main_menu {
  flex: 8;
  min-width: 800px;
}
</style>
